import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'
import { IAddPeriodTag, IPeriodTag, IUpdatePeriodTag } from '@/data/models/PeriodTag'

export class PeriodTagApiService extends ApiService {
  static async getAll(): Promise<IServiceResponse<IPeriodTag[]>> {
    return this.axios.get('period-tags')
      .then((response: AxiosResponse<IServiceResponse<IPeriodTag[]>>) => response.data)
  }

  static async create(periodTag: IAddPeriodTag): Promise<IServiceResponse<IPeriodTag>> {
    return this.axios.post('period-tags', periodTag)
      .then((response: AxiosResponse<IServiceResponse<IPeriodTag>>) => response.data)
  }

  static async update(periodTag: IUpdatePeriodTag): Promise<IServiceResponse<IPeriodTag>> {
    return this.axios.put(`period-tags/${periodTag.id}`, periodTag)
      .then((response: AxiosResponse<IServiceResponse<IPeriodTag>>) => response.data)
  }

  static async delete(periodTagId: number): Promise<AxiosResponse> {
    return this.axios.delete(`period-tags/${periodTagId}`)
  }
}
